import { render, staticRenderFns } from "./PrintStockSummary.vue?vue&type=template&id=22f5a2b0&scoped=true"
import script from "./PrintStockSummary.vue?vue&type=script&lang=js"
export * from "./PrintStockSummary.vue?vue&type=script&lang=js"
import style0 from "./PrintStockSummary.vue?vue&type=style&index=0&id=22f5a2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5a2b0",
  null
  
)

export default component.exports